import {TBadgeColor} from 'src/components';

import {ELicenseStatus, TLicense, TLicenseStatus} from './definitions';

export const colorHash: Record<TLicenseStatus, TBadgeColor> = {
  NEW: 'PINK',
  ACTIVE: 'GREEN',
  ACTIVE_DEBT: 'PINK',
  CANCELLED: 'GREY',
  EXPIRED: 'RED',
  TEMPORARY_BLOCKED: 'GREY',
};

export const prepareLicenses = (licenses: TLicense[]) => {
  const result = {} as Record<TLicenseStatus, number>;

  licenses.forEach((item) => {
    if (result[item.status]) {
      result[item.status] += 1;
    } else {
      result[item.status] = 1;
    }
  });

  return result;
};

export const isActiveLicense = (status: TLicenseStatus) =>
  status === ELicenseStatus.ACTIVE || status === ELicenseStatus.ACTIVE_DEBT;

export const isNeedAttentionLicenseStatus = (licenseStatus: TLicenseStatus) =>
  licenseStatus === ELicenseStatus.NEW || licenseStatus === ELicenseStatus.ACTIVE_DEBT;
